import { Route } from "@angular/router";
import { AuthService } from "./services/auth.service";

export const routes: Route[] = [
  {
    path: "credit-application",
    pathMatch: "full",
    loadComponent: () => import("./pages/credit-application/credit-application.component").then((m) => m.CreditApplicationComponent),
    canActivate: [AuthService],
  },
  {
    path: "submission-page",
    loadComponent: () => import("./pages/submission-page.component").then((m) => m.SubmissionPageComponent),
  },
  {
    path: "access-denied",
    loadComponent: () => import("./pages/error403.component").then((m) => m.Error403Component),
  },
  {
    path: "credit-application/external",
    loadComponent: () => import("./pages/credit-application/credit-application.component").then((m) => m.CreditApplicationComponent),
    canActivate: [AuthService],
    data: {
      pageTitle: "",
      url: "external",
      appendToParent: "search",
    },
  },
  {
    path: "general",
    loadComponent: () => import("./pages/login.component").then((m) => m.LoginComponent),
  },
  {
    path: "",
    redirectTo: "general",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "general",
    pathMatch: "full",
  },
];
